import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Container from "@material-ui/core/Container";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import { connect } from "react-redux";

import routes from "../../constants/RoutesData";

const useStyles = makeStyles((theme) => ({
  buttonSpacing: {
    marginBottom: "75px",
    "& > *": {
      margin: theme.spacing(1),
      marginLeft: 0,
    },
  },
  searchInputSize: {
    minWidth: 300,
  },
}));

  // Function to get the dashboard URL
 export const getDashboardUrl = () => {
    const loginHost = getCookie("login_host");
    return loginHost ? `https://${loginHost}` : process.env.REACT_APP_LOGIN_URL;
  };

 // Function to get the logut URL
 export const getLogoutUrl = () => {
  const loginHost = getCookie("login_host");
  return loginHost ? `https://${loginHost}/admin/logout` : process.env.REACT_APP_LOGOUT_URL;
};

  export const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
  };


const filterDashboardActions = (arr, menus) =>
  arr.filter((val) => val.showInDashboard && menus.has(val.menuName));

const Home = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const allActions = filterDashboardActions(
    Object.values(routes.routesData),
    props.menus
  );
  const [dashboardActionsList, setDashboardActionsList] = useState(allActions);

  const onInputHandler = (evt) => {
    let query = evt.target.value;
    let actionsList = [];
    if (query.length > 0) {
      query = query.toLowerCase();
      actionsList = allActions.filter((val, idx) =>
        val.dashboardButtonText.toLowerCase().startsWith(query)
      );
    } else {
      actionsList = allActions;
    }
    setDashboardActionsList(actionsList);
  };

  return (
    <Container>
      <Box
        className="box-container"
        display="flex"
        justifyContent="space-between"
      >
        <p className="mb-20">
          Please click <a href={getDashboardUrl()}>here</a> to go back to the
          old dashboard.
        </p>
        {/* <TextField
          label="Search"
          variant="outlined"
          onInput={onInputHandler}
          size="medium"
          className={classes.searchInputSize}
        /> */}
      </Box>
      {/* <div className={classes.buttonSpacing + " mt-24"}>
        {dashboardActionsList.map((val, idx) => {
          return (
            <Button
              key={idx}
              className="mr-8 mt-6"
              variant="outlined"
              color="primary"
              onClick={() => history.push(val.path)}
            >
              {val.dashboardButtonText}
            </Button>
          );
        })}
      </div> */}
    </Container>
  );
};

const mapStateToProps = (state) => {
  const { MenuActions } = state;
  return {
    menus: MenuActions.menus,
  };
};

export default connect(mapStateToProps, {})(Home);
